import { SET_CPP_CONFIG, CONFIG_ERROR } from "../constants";

const initial_state = {
  loading: true,
  list: [] as any[]
};

interface stateOptions {
  type: string;
  payload?: any;
}

export default function Config(state = initial_state, { type, payload }: stateOptions) {
  switch (type) {
    case CONFIG_ERROR:
      return {
        ...state,
        loading: false,
        error: payload,
      };

    case SET_CPP_CONFIG:
      return {
        ...state,
        loading: false,
        list: payload
      };

    default:
      return state;
  }
}
